import { defineComponent as _defineComponent } from 'vue'
import { watch } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  NavBar,
  Heading,
  BaseText,
  Row,
  BaseIcon
} from '@warrenbrasil/nebraska-web';
import { SideSheet } from '@/modules/common/components/SideSheet';
import { BackButton } from '@/modules/common/components/buttons';

import { IDetails } from '@/modules/transaction/services/product-investment';

import { removeBodyScroll } from '@/modules/common/helpers/browser';

interface EmitEvents {
  (event: 'close'): void;
}
interface Props {
  isOpen: boolean;
  data: IDetails;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsSidebar',
  props: {
    isOpen: { type: Boolean },
    data: null
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props as {
  isOpen: boolean;
  data: IDetails;
}

const router = useRouter();





function onRowClick(action: string) {
  const routerName: { [key: string]: string } = {
    COSTS: 'costs'
  };

  const url = router.resolve({ name: routerName[action] }).href;

  window.open(url, '_blank');
}

watch(
  () => props.isOpen,
  _isOpen => {
    removeBodyScroll();
  }
);

return { __sfc: true,router, props, onRowClick, NavBar, Heading, BaseText, Row, BaseIcon, SideSheet, BackButton }
}

})